import React, { Fragment } from 'react';
import { Button } from '@BICE_Vida/components';

import Label from '../../designSystem/Label';
import Modal from '../../designSystem/Modal';

import styles from './SubmitModal.module.scss';

const SubmitModal = ({
  isOpen,
  closeModal,
  textContent,
  modalActionBehavior,
}: ModalNoUsefulReasonType) => {
  return (
    <Fragment>
      <Modal
        isOpen={isOpen}
        modalClass={styles.modal_container}
        closeOnIcon
        closeOnOverlay
        close={closeModal}
      >
        <div className={styles.modal_parent}>
          <div className={styles.information_content}>
            <img src={textContent.icon} className={styles.svg} alt="queremos seguir mejorando" />
            <Label customClass={styles.title_text} text={textContent.title} />
            <Label customClass={styles.subtitle_text} text={textContent.subtitle} />
          </div>
          <div>
            <Button text={textContent.actionText} variant="primary" onClick={modalActionBehavior} />
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

type ModalNoUsefulReasonType = {
  isOpen: boolean;
  closeModal: () => void;
  modalActionBehavior: () => void;
  textContent: ModalTextContent;
};

type ModalTextContent = {
  icon: string;
  title: string;
  subtitle: string;
  actionText: string;
};

export default SubmitModal;
